import React from 'react';
import PropTypes from 'prop-types';
import { Box, Button, Typography, makeStyles } from '@material-ui/core';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import { FormattedMessage } from 'react-intl';

import modalStyles from './ExportInspectionsModal.styles';
import ownStyles from './ExportErrorContent.styles';

const useStyles = makeStyles(theme => ({ ...modalStyles(theme), ...ownStyles(theme) }));

export const ExportErrorContent = ({ message, hint, details, actions }) => {
  const classes = useStyles();

  return (
    <Box className={classes.statusContainer}>
      <ErrorOutlineIcon className={`${classes.statusIcon} ${classes.statusIcon_error}`} />
      <Typography variant="h6">{message}</Typography>
      {hint && (
        <Typography variant="body2" className={classes.statusHint}>
          {hint}
        </Typography>
      )}
      {details && (
        <Box className={classes.infoBox} marginTop="16px" textAlign="left">
          <Box>
            <Typography variant="caption" className={classes.detailsLabel}>
              <FormattedMessage id="inspections.export.error.technicalDetail" defaultMessage="Detalle técnico:" />
            </Typography>
            <Typography variant="caption">{details}</Typography>
          </Box>
        </Box>
      )}
      <Box className={`${classes.actions} ${classes.actions_centered}`}>
        {actions.map(({ key, label, onClick, variant = 'outlined' }) => (
          <Button key={key} variant={variant} onClick={onClick}>
            {label}
          </Button>
        ))}
      </Box>
    </Box>
  );
};

ExportErrorContent.propTypes = {
  message: PropTypes.node.isRequired,
  hint: PropTypes.node,
  details: PropTypes.node,
  actions: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.node.isRequired,
      onClick: PropTypes.func.isRequired,
      variant: PropTypes.oneOf(['contained', 'outlined'])
    })
  ).isRequired
};
